import { formatDate, isEmptyArray } from "@dirootie-extensions/javascript";
// import { SummaryResource } from "@domain";
import _ from "lodash";
import {
  FILTER_TYPES,
  Initials,
  STATUS_TYPE,
  StatusTag,
} from "taltech-styleguide";
import { createColumnProps } from "./Col.utils";
import { di } from '@dirootie-core/di';
export type SummaryResource = {
  id: string;
  displayName: string;
  description?: string;
  pictureUrl?: string;
  url?: string;
};

export const columnDefaultProps = {
  classes: "test-column",
  sort: false,
};

export const colIdDefaults = {
  dataField: "id",
  hidden: true,
  text: "ID",
};

export const colMinDefaults = {
  classes: "w-10",
  dataField: "creationOptions.min",
  text: "Min",
};
export const colMaxDefaults = {
  classes: "w-10",
  dataField: "creationOptions.max",
  text: "Max",
};

export const colCourseLogoDefaults = {
  classes: "ebd-initials-first",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return (
      <>
        {row.picture?.url ===
        // "https://taltechedubimtesteufugst.blob.core.windows.net/"
        "" ? (
          <Initials className={"m-1"} name={row.name} key={row.id} size="xs" />
        ) : (
          <Initials
            className={"m-1"}
            imageUrl={row.picture.url}
            key={row.id}
            size="xs"
          />
        )}
      </>
    );
  },
};

export const colLecturerDefaults = {
  dataField: "lecturers",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    if (!row.lecturers) {
      return (
        <>
          {/* {_.times(Math.floor(Math.random() * 3) + 1, (index2) => {
            return (
              <Initials
                className={"m-1"}
                key={row.id}
                name={
                  row.name === "Course demo 1" && index2 === 0
                    ? "M"
                    : String.fromCharCode(97 + Math.floor(Math.random() * 26))
                }
                size="xs"
              />
            );
          })} */}
        </>
      );
    }
    if (row.lecturers && row.lecturers.length > 4) {
      const displayedItems = row.lecturers.slice(0, 4); // Extract the first 5 items
      return (
        <>
          {" "}
          <div className="ebd-initials-column">
            {displayedItems.map((x: SummaryResource) => {
              return (
                <div className={"ebd-initials"}>
                  <Initials
                    className={"m-1"}
                    key={x.id}
                    name={x.displayName}
                    imageUrl={x.pictureUrl}
                    size="xs"
                  />
                </div>
              );
            })}
            <div className={"ebd-last-initial"}>
              <div>
                <Initials
                  className={"m-1"}
                  key={row.lecturers[5].id}
                  name={row.lecturers[5].displayName}
                  imageUrl={row.lecturers[5].pictureUrl}
                  size="xs"
                />
              </div>
              <div className={"ebd-remaining-initials"}>
                +{row.lecturers.length - 4}
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="ebd-initials-column">
            {row.lecturers.map((x: SummaryResource) => {
              return (
                <div className={"ebd-initials"}>
                  <Initials
                    className={"m-1"}
                    key={x.id}
                    name={x.displayName}
                    imageUrl={x.pictureUrl}
                    size="xs"
                  />
                </div>
              );
            })}
          </div>
        </>
      );
    }
  },
  text: "Lecturers",
};

export const colNumberDefaults = {
  classes: "w-20",
  dataField: "number",
  text: "Number",
  sort: true,
  filterObject: {
    defaultValue: undefined,
    minChars: 2,
    placeholder: "Number",
    type: FILTER_TYPES.TEXT,
  },
};

export const colSubmissionsDefaults = {
  classes: "w-10",
  dataField: "submissionDate",
  sort: true,
  text: "Submitted",
};

export const colTitleDefaults = {
  dataField: "title",
  sort: true,
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return <div className={"test-column-name"}>{col}</div>;
  },
  text: "Title",
  filterObject: {
    defaultValue: undefined,
    minChars: 3,
    placeholder: "Title",
    type: FILTER_TYPES.TEXT,
  },
};

export const colValueDefaultDefaults = {
  classes: "w-10",
  dataField: "valueDefault",
  text: "Value",
};

export const colEmailDefaults = {
  classes: "w-20",
  dataField: "email",
  sort: true,
  text: "Email",
  filterObject: {
    defaultValue: undefined,
    minChars: 3,
    placeholder: "Email",
    type: FILTER_TYPES.TEXT,
  },
};

export const colNameDefaults = {
  classes: "w-20",
  dataField: "name",
  sort: true,
  text: "Name",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return <div className={"test-column-name"}>{col}</div>;
  },
  filterObject: {
    defaultValue: undefined,
    minChars: 3,
    placeholder: "Name",
    type: FILTER_TYPES.TEXT,
  },
};

export const colFirstNameDefaults = {
  dataField: "firstName",
  sort: true,
  text: "First name",
};

export const colLastNameDefaults = {
  dataField: "lastName",
  sort: true,
  text: "Last name",
};

export const colDescriptionDefaults = {
  classes: "w-30",
  dataField: "description",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return <div className={"test-column-description"}>{col}</div>;
  },
  text: "Description",
};

export const colDateDefaults = createColumnProps(columnDefaultProps, {
  // filterObject: {
  //   defaultValue: undefined,
  //   type: FILTER_TYPES.DATE,
  // },
  formatter: (col: Date) => formatDate(col),
  sort: true,
});

export const colCreatedDateDefaults = createColumnProps(colDateDefaults, {
  classes: "w-20",
  dataField: "createdDate",
  text: "Created Date",
});

export const colModifiedDateDefaults = createColumnProps(colDateDefaults, {
  classes: "w-20",
  dataField: "modifiedDate",
  text: "Modified Date",
});

export const colStartDateDefaults = createColumnProps(colDateDefaults, {
  classes: "w-20",
  dataField: "startDate",
  text: "Start date",
});

export const colEndDateDefaults = createColumnProps(colDateDefaults, {
  classes: "w-20",
  dataField: "endDate",
  text: "End date",
});

export const colEnumDefaults = {
  classes: "w-10",
  dataField: "type",
  sort: true,
  text: "Type",
  formatter: (col: string) => di.str.titleCase(col),
  // filterObject: {
  //   defaultValue: undefined,
  //   minChars: 3,
  //   placeholder: "Name",
  //   type: FILTER_TYPES.MULTISELECT,
  // },
};

export const colInitialsDefaults = {
  classes: "ebd-initials-first",
  dataField: "picture.url",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    const imgUrl =
      _.get(row, "picture.url") ||
      _.get(row, "picture.path") ||
      _.get(row, "user.picture.url") ||
      _.get(row, "user.picture.path") ||
      "";
    return (
      <>
        <Initials
          key={row.id}
          imageUrl={imgUrl}
          name={row.displayName}
          size="xs"
        />
      </>
    );
  },
  sort: false,
  text: "",
};

export const colRoleDefaults = {
  text: "Role",
  dataField: "role",
  formatter: (col: string = "") => di.str.titleCase(col),
};

export const colStateDefaults = {
  dataField: "state",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    let stateType = STATUS_TYPE.DANGER;
    let stateName = "UNKNOWN";
    if (!_.isUndefined(col)) {
      const states = Object.keys(extraData.states).filter(
        (x) => x.toUpperCase() === col.toUpperCase()
      );

      if (!isEmptyArray(states)) {
        const state = extraData.states[states[0]];
        stateType = state.type;
        stateName = state.name;
      }
    }
    return <StatusTag type={stateType}>{di.str.titleCase(stateName)}</StatusTag>;
  },
  formatExtraData: {
    states: {
      active: {
        name: "Active",
        state: "Active",
        type: STATUS_TYPE.SUCCESS,
      },
      archived: {
        name: "Archived",
        state: "Archived",
        type: STATUS_TYPE.INFO,
      },
      finished: {
        name: "Finished",
        state: "Finished",
        type: STATUS_TYPE.LIGHT,
      },
      invited: {
        name: "Invited",
        state: "Invited",
        type: STATUS_TYPE.INFO,
      },
      registered: {
        name: "Registered",
        state: "Registered",
        type: STATUS_TYPE.INFO,
      },
      blocked: {
        name: "Blocked",
        state: "Blocked",
        type: STATUS_TYPE.DANGER,
      },
      suspended: {
        name: "Suspended",
        state: "Suspended",
        type: STATUS_TYPE.WARNING,
      },
    },
  },
  sort: true,
  text: "State",
};
